import PaymentFailed from "../../../Components/Client/PaymentFailed";

const PaymentFailedPage = () => {
  return <PaymentFailed />;
};

export default PaymentFailedPage;
